export default {
    props: {
      effect: {
        type: String,
        default: 'fadein'
      }
    },
    data() {
      return {
        renderData: [],
        activeIndex: 0
      }
    },
    methods: {
        handleTabListClick(index, el) {
            if (!el.disabled) this.activeIndex = index
        }
    }
  }


/** WEBPACK FOOTER **
 ** ./src/Tabset.vue
 **/